const config = {
  tokenKey: "goloka-agent-token",
  userKey: "User",
} as const;

export default config;
